/* global $ */

require('jquery-toast-plugin');

export default {
  makeToast(opts = {}) {
    const options = opts || {};

    const defaults = {
      text: 'Embed saved successfully!',
      heading: 'Success',
      icon: 'success',
      showHideTransition: 'slide',
      allowToastClose: true,
      hideAfter: 3000,
      stack: 5,
      position: 'top-right',
      textAlign: 'left',
      loader: true,
      loaderBg: '#9EC600',
    };

    $.toast(Object.assign(defaults, options));
  },
};
